import { Directive } from '@angular/core';

@Directive({
  selector: '[caTopNavSearch]',
  standalone: false
})
export class TopNavSearchDirective {}
